<template>
    <footer>
    <div class="ws-line my-4"></div>
    <div class="ws-footer-content py-3"></div>
    </footer>
</template>